import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBHYfP5YCQkgN0g0juwxH2JL5FIz6soa1A",
  authDomain: "analytics-df8f4.firebaseapp.com",
  projectId: "analytics-df8f4",
  storageBucket: "analytics-df8f4.appspot.com",
  messagingSenderId: "976478823323",
  appId: "1:976478823323:web:db7f4f83978bac20fff73e",
  measurementId: "G-LFF41KWLN1"
};
// Initialize Firebase

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
